import React from 'react';
import ReactDOM from 'react-dom';

import 'normalize.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';

import App from './App';
import registerServiceWorker from './registerServiceWorker';

import './index.css';

window.jQuery = window.$ = require('jquery/dist/jquery');
require('bootstrap');

ReactDOM.render(<App />, document.getElementById('root'));
window.location.protocol === 'https:' && registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js